import { API } from "aws-amplify";

export default async function checkStatus(data) {
  if (data?.uuid) {
    return await API.post("paLink", "check-status", {
      body: data,
    });
  }
}
